import 'isomorphic-fetch';
import ApiSuggestionsError from './ApiSuggestionsError';
import { API_SUGGESTIONS_NAME, API_END_POINTS } from './apiSuggestionsConstants';
import { buildQueryParamsString, buildMetricsData } from '../common/utils';
import trovitAPI from '../api';
import clientConfig from '../../../parameters/client/config';
import handleApiResponse from '../common/handleApiResponses/trovitFetchResponse';

const ApiSuggestions = Object.create(trovitAPI);

ApiSuggestions.apiName = API_SUGGESTIONS_NAME;

ApiSuggestions.ApiServiceError = ApiSuggestionsError;

ApiSuggestions.fetchSuggestions = function fetchSuggestions({
  countryCode,
  verticalName,
  dealTypeId,
}) {
  const baseEndpoint = clientConfig.searchApi
    .replace('{country_code}', countryCode)
    .replace('{vertical_name}', verticalName);
  const resource = `${baseEndpoint}${API_END_POINTS.FETCH_SUGGESTIONS}`;

  const queryParamsString = dealTypeId
    ? buildQueryParamsString({ countryCode, dealTypeId })
    : buildQueryParamsString({ countryCode });
  const url = `${resource}?${queryParamsString}`;

  const metricsData = buildMetricsData(verticalName, countryCode, 'search', 'suggestions');

  return handleApiResponse(this.trovitFetch(url, 'GET'), metricsData)
    .then(response => response)
    .catch(error => {
      throw error;
    });
};

export default ApiSuggestions;



// WEBPACK FOOTER //
// ./app/sdk/suggestions/ApiSuggestions.js